import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
import { PlaceLinkBox } from '../PlaceLinkBox/PlaceLinkBox';
export const PlaceLinkBlock = ({ placeLinkBoxes, place }) => {
    if (!placeLinkBoxes) {
        return null;
    }
    return (_jsx(Box, { paddingVertical: "spacing.56", children: placeLinkBoxes.map((placeLinkBox, index) => (_jsx(PlaceLinkBox, { ...placeLinkBox }, `${index}-${place?.id || ''}`))) }));
};
